import React from 'react';

/**
 * Компонент для раздела "8. Заключительные положения".
 * @param {object} data - Полный объект данных договора, содержащий информацию о сроках.
 */
const FinalProvisionsSection = ({ data }) => {
  // Регистрация требуется, если срок договора 12 месяцев или более.
  const isRegistrationRequired = data?.term?.durationMonths >= 12;

  return (
    <div className="document-preview-editor">
      <h2 className="special-section-title" style={{ width: '100%', display: 'block', textAlign: 'center', marginBottom: '24px' }}>
        8. Заключительные положения
      </h2>

      <p className="document-preamble">
        <b>8.1.</b> Настоящий Договор считается заключенным с момента подписания его Сторонами и действует до полного исполнения Сторонами своих обязательств.
      </p>

      {isRegistrationRequired ? (
        <p className="document-preamble">
          <b>8.2.</b> Настоящий Договор составлен в трех экземплярах, имеющих равную юридическую силу, по одному для Сторон и один - для регистрирующего органа.
        </p>
      ) : (
        <p className="document-preamble">
          <b>8.2.</b> Настоящий Договор составлен в двух экземплярах, имеющих равную юридическую силу, по одному для Сторон.
        </p>
      )}
    </div>
  );
};

export default FinalProvisionsSection;
